export default __webpack_public_path__ + "static/media/cho_thue_xe_tu_lai_tphcm.1e7cb1c7.svg";